// The metronome's choices as the mixer and the standalone metronome label them.
import type { ClickAccents, ClickRouting, ClickSound, ClickSubdivision } from '@/audio/metronome';

export const CLICK_SOUND_CHOICES: readonly { id: ClickSound; label: string }[] = [
  { id: 'beep', label: 'Beep' },
  { id: 'woodblock', label: 'Wood' },
  { id: 'rim', label: 'Rim' },
  { id: 'cowbell', label: 'Cowbell' },
  { id: 'hihat', label: 'Hi-hat' },
];
export const CLICK_ACCENT_CHOICES: readonly { id: ClickAccents; label: string }[] = [
  { id: 'all', label: 'Every beat' },
  { id: 'two-four', label: '2 and 4' },
  { id: 'one', label: 'The one' },
];
export const CLICK_SUBDIVISION_CHOICES: readonly { id: ClickSubdivision; label: string }[] = [
  { id: 'none', label: 'None' },
  { id: 'eighths', label: '8ths' },
  { id: 'swing', label: 'Swing' },
  { id: 'triplets', label: 'Triplets' },
  { id: 'sixteenths', label: '16ths' },
];
export const CLICK_ROUTING_CHOICES: readonly { id: ClickRouting; label: string }[] = [
  { id: 'pre', label: 'Dry' },
  { id: 'post', label: 'Through reverb' },
];
